import {Device} from "../device";
import {AvdbPricingProduct} from "./avdb-pricing-product";

/**
 * Selected Product
 *
 * Within database pricing, this object is used to represent a specific AVDB product
 * (subscription or single-issue) that the user has selected for a specific device.
 */
export class AvdbPricingSelectedProduct {
	constructor(
		public readonly product: AvdbPricingProduct,
		public readonly device: Device,
		public readonly userSelected: boolean,
	) {}

	equals(other: AvdbPricingSelectedProduct): boolean {
		return (this.product.partKey === other.product.partKey && this.device === other.device);
	}
}
